import { Button } from "@/shared/components/ui/button";
import SecondaryIcon from "../../../../../shared/components/SecondaryIcon";
import Icons from "../../../../../shared/constants/icon.constant";

export type DepositFundsFiatType = "BankTransfer" | "CreditCard";

interface DepositFundsFiatProps {
  onSubmit(method: DepositFundsFiatType): void;
}

export default function DepositFundsFiat({
  onSubmit,
}: Readonly<DepositFundsFiatProps>) {
  return (
    <div className="w-full space-y-3">
      <p>Fiat Deposit Methods</p>
      {/* <Button
        type="button"
        variant="outline"
        className="w-full justify-start rounded-2xl border-transparent bg-tab-item/20 px-4 py-3 text-white hover:bg-tab-item"
        onClick={() => onSubmit("CreditCard")}>
        <div className="flex items-center gap-2">
          <SecondaryIcon
            icon={Icons.CreditCardIcon({ width: 15, height: 15 })}
            isActive
          />
          Credit/Debit Card
        </div>
      </Button> */}
      <Button
        type="button"
        variant="outline"
        className="w-full justify-start rounded-2xl border-transparent bg-tab-item/20 px-4 py-3 text-white hover:bg-tab-item"
        onClick={() => onSubmit("BankTransfer")}>
        <div className="flex items-center gap-2">
          <SecondaryIcon
            icon={Icons.Banking({ width: 15, height: 15 })}
            isActive
          />
          Bank Transfer
        </div>
      </Button>
    </div>
  );
}
